import React from 'react';
import { faqItems, faqContent } from '../data';
import { FAQProps } from '../types';
import FAQPresentation from './FAQPresentation';

const FAQContainer: React.FC<FAQProps> = ({ 
  className, 
  id = 'faq' 
}) => {
  return (
    <FAQPresentation
      id={id}
      heading={faqContent.heading}
      description={faqContent.description}
      faqItems={faqItems}
    />
  );
};

export default FAQContainer;